const PUBLIC_ROUTES = [
  '/sign-up/personal-info',
  '/sign-up/company-info',
  '/sign-up/verify',
  '/forget-password/enter-email',
  '/forget-password/verify',
  '/forget-password/reset-password',
  '/forget-password/reset-password-success',
];
export { PUBLIC_ROUTES };
